import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DetailField({ label, children, className, mono }) {
    return /*#__PURE__*/ _jsxs("dl", {
        className: className,
        children: [
            /*#__PURE__*/ _jsx("dt", {
                className: "text-xs font-medium text-gray-500",
                children: label
            }),
            /*#__PURE__*/ _jsx("dd", {
                className: `mt-0.5 text-sm text-gray-900${mono ? " font-mono" : ""}`,
                children: children
            })
        ]
    });
}
